module.exports = __webpack_public_path__ + "static/img/select_arrow_down.c456e342.svg";